import { render } from "./nestedLabelLayer.vue?vue&type=template&id=1251a1d8&scoped=true"
import script from "./nestedLabelLayer.vue?vue&type=script&lang=js"
export * from "./nestedLabelLayer.vue?vue&type=script&lang=js"

import "./nestedLabelLayer.vue?vue&type=style&index=0&id=1251a1d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1251a1d8"]])

export default __exports__